import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-buttons',
  templateUrl: './ui-buttons.component.html',
  styleUrls: ['./ui-buttons.component.scss']
})
export class UiButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
